import axios from 'axios';
import {AxiosContext} from 'components/utils/AxiosProvider';
// import isObject from 'isobject';
import {useContext, useEffect, useState} from 'react';
import {cleanVessel} from './useGetEndpoint';

const pageSize = 100;

const usePostVesselSearch = (
    query,
    pageNumber,
    useCached = false,
    cache = false
) => {
    const [isLoading, setIsLoading] = useState(false);
    const [vessels, setVessels] = useState([]);
    const [nResults, setNResults] = useState(null);
    const [error, setError] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const {client: axiosClient} = useContext(AxiosContext);

    useEffect(() => {
        setVessels([]);
        setError(null);
        setNResults(null);
    }, [query]);

    useEffect(() => {
        let cancel = () => {};
        if (axiosClient && query?.length > 2) {
            setIsLoading(true);
            axiosClient
                .post(
                    '/api/1/vessels/search',
                    {
                        search_string: query,
                        start_page: pageNumber,
                        num_items: pageSize,
                    },
                    {
                        useCache: useCached,
                        cache: cache,
                        cancelToken: new axios.CancelToken(c => (cancel = c)),
                    }
                )
                .then(result => {
                    setError(null);
                    setIsLoading(false);
                    const tempVessels = [
                        ...(result?.data?.vessels || []),
                        ...(result?.data?.external_vessels || []),
                    ];
                    const newVessels = tempVessels?.map(vessel =>
                        cleanVessel(vessel)
                    );
                    const totalResults = result?.data?.number_of_results;
                    setNResults(totalResults);
                    setHasMore(totalResults - pageSize * pageNumber > 0);
                    setVessels(prevVessels => [...prevVessels, ...newVessels]);
                })
                .catch(e => {
                    if (axios.isCancel(e)) return;
                    setError(e);
                    setIsLoading(false);
                    setVessels([]);
                    setNResults(null);
                });
        } else if (!query) {
            setError(null);
            setIsLoading(false);
            setVessels([]);
            setNResults(null);
        }
        //eslint-disable-next-line
        return () => cancel();
    }, [query, axiosClient, pageNumber, cache, useCached]);

    return {
        vessels,
        nResults,
        isLoading,
        error,
        hasMore,
    };
};

export default usePostVesselSearch;
